const filterChanges = ({ order, changes, optimisticActivityEnabled }) => {
  if (optimisticActivityEnabled && order.hasOptimisticStatus) {
    const newChanges = { ...changes }
    const updatedOrder = order.update(newChanges)
    if (!updatedOrder.hasOptimisticStatus && updatedOrder.exodusStatus === 'in-progress') {
      delete newChanges.status
      delete newChanges.toTxId
      return newChanges
    }
  }

  return changes
}

export default filterChanges
